// src/routes/packagesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Packages from '../pages/packages/Packages';
import CreatePackage from '../pages/packages/CreatePackage';
import EditPackage from '../pages/packages/EditPackage';
import ProtectedRoute from '../components/global/ProtectedRoute';

const packagesRoutes = (
    <>
        {/* Packages List */}
        <Route
            path="/packages"
            element={
                <ProtectedRoute requiredPermission="packages_list">
                    <Packages />
                </ProtectedRoute>
            }
        />

        {/* Packages Archive */}
        <Route
            path="/packages/archive"
            element={
                <ProtectedRoute requiredPermission="packages_archive_list">
                    <Packages />
                </ProtectedRoute>
            }
        />

        {/* Create Package */}
        <Route
            path="/packages/create"
            element={
                <ProtectedRoute requiredPermission="packages_create">
                    <CreatePackage />
                </ProtectedRoute>
            }
        />

        {/* Edit Package */}
        <Route
            path="/packages/:id/edit"
            element={
                <ProtectedRoute requiredPermission="packages_edit">
                    <EditPackage />
                </ProtectedRoute>
            }
        />
    </>
);

export default packagesRoutes;
